import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import Axios from '../../../services/AxiosInterceptor';


const Location = () => {
  const [list,setList]=useState();
  const navigate=useNavigate()
  
  console.log(list)
const getLocationList = async () => {
  try {
    const response = await Axios.get("api/location-list");

    console.log("locationlist", response);

    // Axios returns data at response.data
    const data = response.data;

    // Reverse if data is an array
    const reversedData = Array.isArray(data) ? [...data].reverse() : data;

    setList(reversedData);

  } catch (error) {
    console.error("Error fetching location list:", error);
  }
};

  useEffect(() => {
    getLocationList();
  }, []);

  const handleEdit=(record)=>{
    navigate(`/edit-location/${record._id}`)
// console.log(record._id)
  }
 const handleDelete = async (id) => {
  try {
    const response = await Axios.post("/api/location-list-delete", {
      id: id   // <-- body data goes directly here
    });

    if (response.data) {
      window.location.reload();
    }
  } catch (error) {
    console.log(error);
  }
};

  const columns = [
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Postal",
      dataIndex: "postal",
      key: "postal",
    },
    {
      title: "Resource Count",
      dataIndex: "resource",
      key: "resourceCount",
      render: (resource) => {
        return resource.length;
      },
    },

    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button 
            icon={<EditOutlined />} 
            onClick={() => handleEdit(record)} 
            type="primary"
          >
            Edit
          </Button>
          <Button 
            icon={<DeleteOutlined />} 
            onClick={() => handleDelete(record._id)} 
            danger
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  const handleAdd=()=>{
    navigate("/Add-location")
  }

  return (
    <div>
 <h3>Location List</h3>
 <Button onClick={handleAdd}>Add Location</Button>
      <Table
        columns={columns} 
        dataSource={list}
        rowKey="_id" 
        pagination={false} 
      />




    </div>
  )
}
export default Location;
